import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface ErrorModalProps {
  open: boolean;
  message?: string;
  title?: string;
  onClose: () => void;
}

const DEFAULT_TITLE = "We're Experiencing Technical Issues";
const DEFAULT_MESSAGE =
  "We're sorry, we are experiencing technical issues at this time. Please refresh the page and try again. If the problem persists, please reach out to technical support.";

const ErrorModal = (props: ErrorModalProps) => {
  const { open, onClose, title, message } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="error-dialog"
      aria-describedby="error-dialog-description"
    >
      <DialogTitle id="error-dialog">{title || DEFAULT_TITLE}</DialogTitle>
      <DialogContent>
        <DialogContentText id="error-dialog-description">
          {message || DEFAULT_MESSAGE}
        </DialogContentText>
      </DialogContent>
      {/* <DialogActions>
                <Button onClick={handleClose}>Disagree</Button>
                <Button onClick={handleClose} autoFocus>
                    Agree
                </Button>
            </DialogActions> */}
    </Dialog>
  );
};

export default ErrorModal;
